import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import { Close as CloseIcon, InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import DocumentMarkdown from '../DocumentMarkdown';
import { RULEBOOK_IDS } from '../../constants/rulebooks';
import { fetchRulebookById } from '../../utils/rulebooks';

export function CustomPatientSimulationRulebookButton({ size = 'medium' }) {
  const [open, setOpen] = useState(false);
  const [markdown, setMarkdown] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchRulebookById(RULEBOOK_IDS.CUSTOM_PATIENT_SIMULATION)
      .then(({ markdown: text }) => {
        if (!cancelled) setMarkdown(text);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'Could not load the guide.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open]);

  return (
    <>
      <IconButton
        size={size}
        color="primary"
        aria-label="Open custom patient simulation mapping guide"
        onClick={() => setOpen(true)}
      >
        <InfoOutlinedIcon fontSize={size === 'small' ? 'small' : 'medium'} />
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth scroll="paper">
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
          Custom patient simulation
          <IconButton aria-label="Close" onClick={() => setOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress size={32} />
            </Box>
          ) : null}
          {error ? (
            <Typography color="error">{error}</Typography>
          ) : null}
          {!loading && !error ? <DocumentMarkdown content={markdown} /> : null}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default CustomPatientSimulationRulebookButton;
